import React from 'react';
import './emoji_attribution.scss';

export default function EmojiAttribution() {
  return (
    <div className="emoji-attribution">
      Emoji icons supplied by <a href="http://emojione.com" target="blank">EmojiOne</a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/app_footer/emoji_attribution/emoji_attribution.jsx